/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import Header from "./header"
import Footer from "./footer"
import { GlobalStyle } from "./mediaCSS"
import SEO from "../components/seo"

import { media, styled } from "./mediaCSS"

const Main = styled.main`
  display: flex;
`

const MainLeft = styled.div`
  padding: 10px;
  background: #ffffff;
  background-image: url("/sideBar2.jpg");
  background-repeat: no-repeat;

  flex: 1 20%;
  display: none;

  ${media.desktop`
  display: block;
  `}
`

const MainRight = styled.div`
  padding: 10px;
  background: #ffffff;
  background-image: url("/sideBar1.jpg");
  background-repeat: no-repeat;
  flex: 1 20%;
  display: none;
  min-height: 800px;

  ${media.desktop`
  display: block;
  `}
`

const MainContent = styled.div`
  margin-top: 30px;
  padding-bottom: 50px;
  padding-left: 10px;
  padding-right: 10px;
  flex: 3 1 100%;
`

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <GlobalStyle />
        <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
        <Header />

        <Main>
          <MainLeft></MainLeft>
          <MainContent>{children}</MainContent>
          <MainRight />
        </Main>
        <Footer />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
